import React from 'react';

import './ProgressBar.css';

function Progress() {
  return (
  <>
      <div className='container text-center'>
        {/* row 1 */}
        <div className='row'>
          <div className='col'>
            <img className='html' src={'images/svg/html.svg'} alt='html' />
            <p className='skil'>HTML</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/css.svg'} alt='css' />
            <p className='skil'>CSS</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/js.svg'} alt='js' />
            <p className='skil'>JS</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/react.svg'} alt='react' />
            <p className='skil'>React Js</p>
          </div>
          
        </div>
          {/* row 2 */}
        <div className='row'>
        <div className='col'>
            <img className='html' src={'images/svg/jq.png'} alt='af' />
            <p className='skil'>jQuery</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/my_sql.png'} alt='af' />
            <p className='skil'>MySQL</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/w.svg'} alt='wordpress' />
            <p className='skil'>WordPress</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/mui.svg'} alt='mui' />
            <p className='skil'>Material UI</p>
          </div>
          
        </div>
        {/* row 3 */}
        
        <div className='row'>
          <div className='col'>
            <img className='html' src={'images/svg/go.svg'} alt='af' />
            <p className='skil'>GoDaddy</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/fz.svg'} alt='af' />
            <p className='skil'>FileZilla</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/bl.svg'} alt='af' />
            <p className='skil'>Blender</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/cy.webp'} alt='af' />
            <p className='skil'>Cyclic</p>
          </div>
          </div>

        {/* Row4 */}
        <div className='row'>
          <div className='col'>
            <img className='html' src={'images/svg/after.svg'} alt='af' />
            <p className='skil'>After Effects</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/xd.svg'} alt='xd' />
            <p className='skil'>Adobe XD</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/pr.svg'} alt='pp' />
            <p className='skil'>Premiere Pro</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/ps.svg'} alt='ps' />
            <p className='skil'>Photoshop</p>
          </div>
          
        </div>
        <div className='row'>
          <div className='col'>
            <img className='html' src={'images/svg/framer.svg'} alt='af' />
            <p className='skil'>Framer</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/wf.svg'} alt='af' />
            <p className='skil'>Webflow</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/ne.svg'} alt='af' />
            <p className='skil'>Netlify</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/ren.svg'} alt='af' />
            <p className='skil'>Render</p>
          </div>
          </div>


          <div className='row'>
          <div className='col'>
            <img className='html' src={'images/svg/an.svg'} alt='af' />
            <p className='skil'>Google Analytics</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/ad.svg'} alt='af' />
            <p className='skil'>Adsense</p>
          </div>
          <div className='col'>
            <img className='html' src={'images/svg/github.svg'} alt='github' />
            <p className='skil'>GitHub</p>
          </div>

          <div className='col'>
            <img className='html' src={'images/svg/b.svg'} alt='bootstrap' />
            <p className='skil'>Bootstrap</p>
          </div>
          </div>

      </div>


      
  </>
  );
}

export default Progress;